(function () {
  function initHeader() {
    var header = document.querySelector('[data-tbf-header]');
    if (!header || header.dataset.tbfHeaderReady === '1') return;
    header.dataset.tbfHeaderReady = '1';
    var toggle = header.querySelector('[data-tbf-menu-toggle]');
    var closeBtn = header.querySelector('[data-tbf-menu-close]');
    var drawer = header.querySelector('[data-tbf-drawer]');
    if (!toggle) return;

    var lastFocus = null;

    function focusables() {
      if (!drawer) return [];
      return Array.prototype.slice.call(
        drawer.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) {
        return !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true';
      });
    }

    function close() {
      if (!header.classList.contains('is-open')) return;
      header.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Menu');
      if (drawer) drawer.setAttribute('hidden', '');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      if (header.dataset.tbfScrollY) {
        window.scrollTo(0, Number(header.dataset.tbfScrollY) || 0);
        delete header.dataset.tbfScrollY;
      }
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      lastFocus = null;
    }

    // Funnel destinations only (2026-09-17). This array is the JS rebuild of the
    // drawer in sections/tbf-header.liquid, so it has to carry the same four
    // links as that section's funnel branch: the legacy PDPs and the retired
    // Perimenopause and Postpartum programs were removed from both, because a
    // drawer rebuilt from here would otherwise overwrite the section's correct
    // funnel markup with live catalog links the moment the menu is opened.
    var DRAWER_LINKS = [
      { id: 'wlr', href: '/products/weightloss-reset-tbf', label: 'Weight Loss Reset' },
      { id: 'bundles', href: '/products/bundle-and-save', label: 'Bundle & Save' },
      { id: 'quiz', href: '/pages/tbf-quiz', label: 'Find Your Program' },
      { id: 'transformations', href: '/pages/transformation-tbf', label: 'Transformations' }
    ];

    // Same rule as the desktop nav in sections/tbf-header.liquid, so the two
    // cannot drift: compare the pathname (a trailing slash is ignored) and
    // accept the link path itself, a locale/market prefix in front of it, or a
    // deeper path under it. Never a substring test — "/pages/transformation-tbf"
    // must not light up on "/pages/transformation-tbf-page-2".
    function drawerPath() {
      var path = String((window.location && window.location.pathname) || '');
      if (path.length > 1 && path.charAt(path.length - 1) === '/') path = path.slice(0, -1);
      return path;
    }

    function drawerLinkMatches(path, href) {
      if (!path || !href || path.length < href.length) return false;
      if (path === href) return true;
      var tailStart = path.length - href.length;
      if (path.slice(tailStart, tailStart + href.length) === href) return true;
      return path.slice(0, href.length + 1) === href + '/';
    }

    function buildDrawer() {
      if (!drawer) return;
      drawer.innerHTML = '';
      var path = drawerPath();
      DRAWER_LINKS.forEach(function (item) {
        var a = document.createElement('a');
        a.className = 'tbf-header__drawer-link';
        a.setAttribute('data-tbf-nav', item.id);
        a.href = item.href;
        a.textContent = item.label;
        if (drawerLinkMatches(path, item.href)) {
          a.className += ' is-active';
          // A deeper path under a link still highlights it, but only the link's
          // own page claims aria-current="page".
          if (path === item.href) a.setAttribute('aria-current', 'page');
        }
        a.addEventListener('click', close);
        drawer.appendChild(a);
      });
    }
    buildDrawer();

    function open() {
      lastFocus = document.activeElement;
      header.dataset.tbfScrollY = String(window.scrollY || window.pageYOffset || 0);
      header.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      if (drawer) {
        // Re-assert links in case an A/B tool stripped Weight Loss Reset.
        if (!drawer.querySelector('[data-tbf-nav="wlr"]') || drawer.children.length < DRAWER_LINKS.length) {
          buildDrawer();
        }
        drawer.removeAttribute('hidden');
      }
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + header.dataset.tbfScrollY + 'px';
      document.body.style.width = '100%';
      var items = focusables();
      var target = closeBtn || items[0] || toggle;
      if (target && typeof target.focus === 'function') {
        window.setTimeout(function () { target.focus(); }, 0);
      }
    }

    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (header.classList.contains('is-open')) close();
      else open();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        close();
      });
    }

    document.addEventListener('keydown', function (e) {
      if (!header.classList.contains('is-open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        close();
        return;
      }
      if (e.key !== 'Tab') return;
      var items = focusables();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    window.matchMedia('(min-width: 1025px)').addEventListener('change', function (e) {
      if (e.matches) close();
    });
  }

  function initStickyCta() {
    /* Sticky CTAs disabled sitewide */
    document.querySelectorAll('[data-tbf-sticky-cta], .tbf-sticky-cta').forEach(function (el) {
      el.remove();
    });
    document.body.classList.remove('has-tbf-sticky');
  }

  function initQuiz() {
    var root = document.querySelector('[data-tbf-quiz]');
    if (!root || root.dataset.tbfQuizReady === '1') return;
    /* Idempotency guard, same idiom as initHeader/initArticleShare/initFooter.
       sections/tbf-quiz.liquid used to carry its own
       <script src="tbf-brand.js"> on top of layout/theme.liquid's, so this file
       executed twice on /pages/tbf-quiz and every quiz handler was bound twice.
       That was measurable: one click on Start rendered the question's options
       twice (six nodes added, three removed), and the two closures raced over one
       DOM with the winner decided by listener order. The duplicate tag has since
       been removed from the section, but the guard stays: it costs one DOM
       property and keeps the init safe to include from more than one place, which
       is what the other inits here already assume. */
    root.dataset.tbfQuizReady = '1';

    // Live price copy rendered server-side from the real products, keyed by
    // result. Missing or malformed JSON leaves this empty, which costs the
    // cards their figures but never shows a stale one.
    var quizPriceCopy = {};
    var priceCopyEl = root.querySelector('[data-quiz-price-copy]');
    if (priceCopyEl) {
      try {
        quizPriceCopy = JSON.parse(priceCopyEl.textContent) || {};
      } catch (e) {
        quizPriceCopy = {};
      }
    }

    function resultCopy(key) {
      return quizPriceCopy[key] || {};
    }

    var questions = [
      {
        text: 'What matters most right now?',
        options: [
          { label: 'Losing weight and feeling lighter', result: 'wlr' },
          { label: 'Getting strong', result: 'strength' },
          { label: 'Tone, shape and definition', result: 'sculpt' },
          { label: 'Low-impact Pilates for core and posture', result: 'pilates' },
          { label: 'High-intensity workouts with Pilates', result: 'hiit' },
          { label: 'Hormonal changes / perimenopause', result: 'peri' },
          { label: 'Recovering after having a baby', result: 'postpartum' },
          { label: 'Staying active while pregnant', result: 'pregnancy' }
        ]
      },
      {
        text: 'How much time can you give most days?',
        options: [
          { label: 'About 15–20 minutes', result: 'wlr' },
          { label: '20–30 minutes of lifting', result: 'strength' },
          { label: '20–30 minutes mixing resistance and conditioning', result: 'sculpt' },
          { label: 'Short, low-impact sessions', result: 'pilates' },
          { label: 'Three hard sessions a week', result: 'hiit' },
          { label: 'I need something flexible around symptoms', result: 'peri' },
          { label: 'Short sessions I can stop/start with baby', result: 'postpartum' },
          { label: 'Gentle sessions that change with each trimester', result: 'pregnancy' }
        ]
      },
      {
        text: 'Where will you train?',
        options: [
          { label: 'At home — minimal equipment', result: 'wlr' },
          { label: 'At home with bands and weights', result: 'strength' },
          { label: 'Home or gym — whatever helps me shape up', result: 'sculpt' },
          { label: 'At home on a mat', result: 'pilates' },
          { label: 'Anywhere — no equipment', result: 'hiit' },
          { label: 'Wherever I feel up to it that day', result: 'peri' },
          { label: 'At home around nap times', result: 'postpartum' },
          { label: 'At home, at my own pace', result: 'pregnancy' }
        ]
      },
      {
        text: 'How do you feel about food right now?',
        options: [
          { label: 'I want simple structure without restriction', result: 'wlr' },
          { label: 'I want to fuel training and recovery', result: 'strength' },
          { label: 'I want meals that support tone and definition', result: 'sculpt' },
          { label: 'I want simple, balanced meals', result: 'pilates' },
          { label: 'I want meals that keep my energy up', result: 'hiit' },
          { label: 'My appetite and energy feel unpredictable', result: 'peri' },
          { label: 'I need nourishment that fits feeding / recovery', result: 'postpartum' },
          { label: 'I need nourishment for me and my baby', result: 'pregnancy' }
        ]
      },
      {
        text: 'What would make this feel like a win?',
        options: [
          { label: 'Clothes fitting better and energy back', result: 'wlr' },
          { label: 'Visible strength', result: 'strength' },
          { label: 'Defined shape and curves', result: 'sculpt' },
          { label: 'The full transformation — all levels', result: 'bundle' },
          { label: 'A stronger core and better posture', result: 'pilates' },
          { label: 'Fitter, with more stamina', result: 'hiit' },
          { label: 'More energy and fewer hormonal symptoms', result: 'peri' },
          { label: 'Feeling strong and supported postpartum', result: 'postpartum' },
          { label: 'Feeling strong and energised through my pregnancy', result: 'pregnancy' }
        ]
      }
    ];

    // No prices here on purpose. Figures come from the [data-quiz-price-copy]
    // JSON that sections/tbf-quiz.liquid renders from the live products, so they
    // cannot go stale and they follow the visitor's market currency. The `cta`
    // values below are price-free fallbacks: if that JSON is ever missing we
    // lose the figure rather than show a wrong one.
    //
    // This quiz is a funnel surface, so every result CTA has to land on a
    // noindexed funnel destination rather than the live, indexed PDP --
    // otherwise the visitor leaves the cohort mid-answer. Weight Loss Reset and
    // the bundle keep their funnel products; every other program has its own
    // page.tbf-<program> landing page. Keep these paths in the route gate's
    // allowlist (snippets/tbf-funnel-head.liquid).
    var FUNNEL_WLR = '/products/weightloss-reset-tbf';
    var FUNNEL_BUNDLE = '/products/bundle-and-save';

    var results = {
      wlr: {
        name: 'a Weight Loss Reset woman',
        desc: "You're ready for a clear 8-week plan — training, food and support that fits a real week.",
        program: 'Weight Loss Reset',
        href: FUNNEL_WLR,
        cta: 'Start the Weight Loss Reset'
      },
      strength: {
        name: 'The Powerhouse',
        desc: "You're not chasing a number on the scale — you want to feel strong. Strength & Tone is built around structured lifting and real recovery.",
        program: 'Strength & Tone',
        href: '/pages/tbf-strength-and-tone',
        cta: 'See Strength & Tone'
      },
      sculpt: {
        name: 'The Sculptor',
        desc: 'You want definition and shape, not just getting smaller. Shape & Sculpt mixes resistance and conditioning to get you there.',
        program: 'Shape & Sculpt',
        href: '/pages/tbf-shape-and-sculpt',
        cta: 'See Shape & Sculpt'
      },
      bundle: {
        name: 'built for the full Transform path',
        desc: 'You want the complete system — Weight Loss Reset, Strength & Tone, Shape & Sculpt, equipment and the Lifestyle Library in one go.',
        program: 'Ultimate Transformation Bundle',
        href: FUNNEL_BUNDLE,
        cta: 'Get the Bundle'
      },
      pilates: {
        name: 'all about low-impact strength',
        desc: 'You want to feel strong and centred without the pounding. Pilates Express is short, low-impact sessions focused on core, posture and control.',
        program: 'Pilates Express',
        href: '/pages/tbf-pilates-express',
        cta: 'See Pilates Express'
      },
      hiit: {
        name: 'ready to turn up the intensity',
        desc: 'You want real fitness results in minimal time. HIIT Pilates pairs high-intensity intervals with Pilates control — three full-body classes a week, no equipment.',
        program: 'HIIT Pilates',
        href: '/pages/tbf-hiit-pilates',
        cta: 'See HIIT Pilates'
      },
      peri: {
        name: 'in your perimenopause chapter',
        desc: 'Hormonal change needs a different approach. Perimenopause is built for this stage — training and support that flex with your energy.',
        program: 'Perimenopause',
        href: '/pages/tbf-perimenopause',
        cta: 'See Perimenopause'
      },
      postpartum: {
        name: 'rebuilding after baby',
        desc: 'You need training and recovery that respects where your body is now — not a generic reboot.',
        program: 'Postpartum Program',
        href: '/pages/tbf-postpartum',
        cta: 'See Postpartum'
      },
      pregnancy: {
        name: 'growing a little one',
        desc: 'You want to stay active, energised and balanced through every trimester. TRANSFORM Pregnancy has safe Pilates and yoga sessions and nutrition for each stage.',
        program: 'TRANSFORM Pregnancy',
        href: '/pages/tbf-pregnancy',
        cta: 'See Pregnancy'
      }
    };

    // Only the three levels are part of the bundle, so only their results
    // carry the bundle upsell.
    var BUNDLE_UPSELL = ['wlr', 'strength', 'sculpt'];

    function emptyScores() {
      var s = {};
      Object.keys(results).forEach(function (k) {
        s[k] = 0;
      });
      return s;
    }

    var scores = emptyScores();
    var answers = [];
    var step = -1;

    function resetScores() {
      scores = emptyScores();
      answers.forEach(function (result, idx) {
        var weight = idx === 0 || idx === questions.length - 1 ? 2 : 1;
        scores[result] += weight;
      });
    }

    function pickWinner() {
      var primary = answers[0];
      var final = answers[questions.length - 1];

      // Life stage decides the program outright.
      if (primary === 'pregnancy' || primary === 'postpartum' || primary === 'peri') return primary;
      if (final === 'bundle') return 'bundle';

      var winner = 'wlr';
      var max = -1;
      Object.keys(scores).forEach(function (k) {
        if (scores[k] > max) {
          max = scores[k];
          winner = k;
        }
      });

      if (primary && scores[primary] === max) return primary;
      return winner;
    }

    var intro = root.querySelector('[data-quiz-intro]');
    var questionEl = root.querySelector('[data-quiz-question]');
    var resultEl = root.querySelector('[data-quiz-result]');
    var progressWrap = root.querySelector('[data-quiz-progress]');
    var progressFill = root.querySelector('[data-quiz-fill]');
    var progressLabel = root.querySelector('[data-quiz-step-label]');
    var qText = root.querySelector('[data-quiz-q-text]');
    var optionsEl = root.querySelector('[data-quiz-options]');
    var backBtn = root.querySelector('[data-quiz-back]');

    function show(el) {
      [intro, questionEl, resultEl].forEach(function (n) {
        if (n) n.classList.add('tbf-hide');
      });
      if (el) el.classList.remove('tbf-hide');
    }

    function renderQuestion() {
      var q = questions[step];
      qText.textContent = q.text;
      optionsEl.innerHTML = '';
      q.options.forEach(function (opt) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'tbf-quiz__option';
        btn.textContent = opt.label;
        btn.addEventListener('click', function () {
          answers[step] = opt.result;
          resetScores();
          if (step < questions.length - 1) {
            step += 1;
            updateProgress();
            renderQuestion();
          } else {
            showResult();
          }
        });
        optionsEl.appendChild(btn);
      });
      show(questionEl);
      if (backBtn) backBtn.classList.toggle('tbf-hide', step < 0);
      updateProgress();
    }

    function updateProgress() {
      if (!progressWrap) return;
      if (step < 0) {
        progressWrap.classList.add('tbf-hide');
        return;
      }
      progressWrap.classList.remove('tbf-hide');
      var pct = ((step + 1) / questions.length) * 100;
      progressFill.style.width = pct + '%';
      progressLabel.textContent = 'Question ' + (step + 1) + ' of ' + questions.length;
    }

    function showResult() {
      var winner = pickWinner();
      var r = results[winner];
      var copy = resultCopy(winner);
      root.querySelector('[data-quiz-result-name]').textContent = "You're " + r.name + '.';
      root.querySelector('[data-quiz-result-desc]').textContent = r.desc;
      root.querySelector('[data-quiz-result-program]').textContent = r.program;
      var priceEl = root.querySelector('[data-quiz-result-price]');
      // innerHTML, not textContent: the money is a formatted <span> so that the
      // storefront's currency conversion picks it up like every other price.
      if (priceEl) priceEl.innerHTML = copy.price || '';
      var cta = root.querySelector('[data-quiz-result-cta]');
      cta.innerHTML = copy.cta || r.cta;
      cta.setAttribute('href', r.href);
      var secondary = root.querySelector('[data-quiz-result-secondary]');
      if (secondary) {
        if (BUNDLE_UPSELL.indexOf(winner) === -1) secondary.classList.add('tbf-hide');
        else {
          secondary.classList.remove('tbf-hide');
          secondary.textContent = 'See Bundle & Save →';
          secondary.setAttribute('href', FUNNEL_BUNDLE);
        }
      }
      if (progressWrap) progressWrap.classList.add('tbf-hide');
      if (backBtn) backBtn.classList.add('tbf-hide');
      show(resultEl);
    }

    var startBtn = root.querySelector('[data-quiz-start]');
    if (startBtn) {
      startBtn.addEventListener('click', function () {
        step = 0;
        answers = [];
        resetScores();
        renderQuestion();
      });
    }

    if (backBtn) {
      backBtn.addEventListener('click', function () {
        if (step <= 0) {
          step = -1;
          answers = [];
          resetScores();
          show(intro);
          updateProgress();
          backBtn.classList.add('tbf-hide');
          return;
        }
        answers.pop();
        resetScores();
        step -= 1;
        renderQuestion();
      });
    }
  }

  /* Share this article.
     Category filtering is server-side (links to /blogs/<blog>/tagged/<handle>),
     so there is no filter script any more — it only ever hid cards on the
     current page, which silently disagreed with the pagination count. */
  function initArticleShare() {
    var root = document.querySelector('[data-tbf-share]');
    if (!root || root.dataset.tbfShareReady === '1') return;
    root.dataset.tbfShareReady = '1';

    var btn = root.querySelector('[data-tbf-share-btn]');
    var status = root.querySelector('[data-tbf-share-status]');
    if (!btn) return;

    var hideTimer = null;

    function flash(message) {
      if (!status) return;
      status.textContent = message;
      status.classList.add('is-visible');
      if (hideTimer) clearTimeout(hideTimer);
      hideTimer = setTimeout(function () {
        status.classList.remove('is-visible');
      }, 2200);
    }

    function copyFallback(url) {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(
          function () { flash('Link copied'); },
          function () { flash('Copy failed'); }
        );
        return;
      }
      /* Older Safari: no async clipboard. A hidden textarea plus execCommand is
         the only remaining route; if it fails we say so rather than pretending. */
      var field = document.createElement('textarea');
      field.value = url;
      field.setAttribute('readonly', '');
      field.style.position = 'absolute';
      field.style.left = '-9999px';
      document.body.appendChild(field);
      field.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
      document.body.removeChild(field);
      flash(ok ? 'Link copied' : 'Copy failed');
    }

    btn.addEventListener('click', function () {
      var url = btn.getAttribute('data-share-url') || window.location.href;
      var title = btn.getAttribute('data-share-title') || document.title;

      if (navigator.share) {
        navigator.share({ title: title, url: url }).catch(function (err) {
          /* Dismissing the sheet is a normal action, not a failure. */
          if (err && err.name === 'AbortError') return;
          copyFallback(url);
        });
        return;
      }

      copyFallback(url);
    });
  }

  /* Recipe ingredients card (snippets/tbf-story-block.liquid).
     The checkboxes are native <input type="checkbox">, so ticking them needs no
     script at all — this only wires the copy button in the card header. The
     list is read out of the DOM rather than out of a data attribute so the
     copied text can never drift from what the reader sees, and so the markup
     does not carry the same copy twice. */
  function initStoryIngredients() {
    var roots = document.querySelectorAll('[data-tbf-ingredients]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.tbfIngredientsReady === '1') return;
      root.dataset.tbfIngredientsReady = '1';

      var btn = root.querySelector('[data-tbf-ingredients-copy]');
      var status = root.querySelector('[data-tbf-ingredients-status]');
      if (!btn) return;

      var timer = null;

      function flash(message) {
        if (status) status.textContent = message;
        btn.classList.add('is-copied');
        if (timer) clearTimeout(timer);
        timer = setTimeout(function () {
          btn.classList.remove('is-copied');
        }, 2000);
      }

      function copy(text) {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(
            function () { flash('Ingredient list copied'); },
            function () { flash('Copy failed'); }
          );
          return;
        }
        /* Same execCommand fallback as the share button: older Safari has no
           async clipboard and is common enough on this audience's phones. */
        var field = document.createElement('textarea');
        field.value = text;
        field.setAttribute('readonly', '');
        field.style.position = 'absolute';
        field.style.left = '-9999px';
        document.body.appendChild(field);
        field.select();
        var ok = false;
        try { ok = document.execCommand('copy'); } catch (e) { ok = false; }
        document.body.removeChild(field);
        flash(ok ? 'Ingredient list copied' : 'Copy failed');
      }

      btn.addEventListener('click', function () {
        var items = [];
        Array.prototype.forEach.call(
          root.querySelectorAll('.tbf-story__ingredient-text'),
          function (el) {
            var text = (el.textContent || '').replace(/\s+/g, ' ').trim();
            if (text) items.push(text);
          }
        );
        if (!items.length) return;
        copy(items.join('\n'));
      });
    });
  }

  /* Add-to-cart double-submit guard.
     Every funnel add form is a native POST to /cart/add, so nothing about the
     browser stops a fast double-click — or a click on another section's button
     before the first navigation commits — from adding the same line twice. The
     landing page differs by template: snippets/tbf-atc-form.liquid sends the
     Weight Loss Reset forms to return_to=/cart and the bundle form to
     return_to=/checkout, but both are full-page POSTs and both are exposed to
     the same double-submit race.

     tbf-product-hero, tbf-value-stack, tbf-guarantee, tbf-pricing and
     tbf-closing-cta all render snippets/tbf-atc-form.liquid (.tbf-product-form)
     against one variant, so the bundle page carries four of those buttons and
     the Weight Loss Reset page five. tbf-upsell-card renders its own
     .tbf-upsell__form against a different variant (program + equipment), and is
     only used on the Weight Loss Reset template.

     One submit locks all of them, including the upsell. Every one of these forms
     leaves the page via a native POST — on the funnel there is no cart-drawer
     root and no ajax-cart-product-form element, so the upsell posts natively too
     — which means anything clicked after the first submit is lost regardless.
     Per-form locks would let a click on the next section's button queue a second
     POST during that window, which is the exact bug being fixed.

     The lock deliberately never sets the `disabled` attribute. The browser
     builds a form's entry list after the submit event, so disabling the
     submitter inside that handler drops its name/value — and the product form
     needs name="add" for Shopify to accept the add. [aria-disabled] plus
     pointer-events (assets/tbf-brand.css) blocks activation while leaving the
     payload intact.

     The lock also releases on pageshow after a bfcache restore (browser Back
     from /cart) and after 15s, so a submit that never navigates — a
     third-party script cancelling it, a stalled network — cannot strand the
     funnel behind a dead button.

     The quiz result CTA ([data-quiz-result-cta]) is covered by the same lock,
     but as an <a> it has no submit event — the click is the activation, so it
     is handled in the click listener. Its href and label are rewritten by the
     quiz for whichever program the visitor matched, so it is selected by that
     data attribute rather than by a URL. Its race is a double navigation rather
     than a double add, which is milder but still worth stopping: two queued
     navigations can restart the load of a slow product page. */
  var TBF_ATC_FORMS = 'form.tbf-product-form, form.tbf-upsell__form';
  var TBF_ATC_BUTTONS =
    'form.tbf-product-form button[type="submit"][name="add"], ' +
    'form.tbf-upsell__form button[type="submit"][name="add"]';
  var TBF_QUIZ_CTA = '[data-quiz-result-cta]';
  var TBF_GUARDED = TBF_ATC_BUTTONS + ', ' + TBF_QUIZ_CTA;

  function initAtcGuard() {
    if (window.__tbfAtcGuard) return;
    window.__tbfAtcGuard = true;

    function setBusy(on) {
      var els = document.querySelectorAll(TBF_GUARDED);
      Array.prototype.forEach.call(els, function (el) {
        if (on) {
          el.classList.add('is-submitting');
          el.setAttribute('aria-busy', 'true');
          el.setAttribute('aria-disabled', 'true');
        } else {
          el.classList.remove('is-submitting');
          el.removeAttribute('aria-busy');
          el.removeAttribute('aria-disabled');
        }
      });
      document.documentElement.classList.toggle('tbf-atc-locked', on);
    }

    var locked = false;
    var releaseTimer = null;

    function release() {
      if (!locked) return;
      locked = false;
      if (releaseTimer) {
        window.clearTimeout(releaseTimer);
        releaseTimer = null;
      }
      setBusy(false);
    }

    /* Exposed for the weightloss-reset-tbf drawer-add interceptor at the end of
       layout/theme.liquid. That template does not navigate on an add, so the
       guard's own release paths (navigation, a persisted pageshow, the 15s
       timeout) no longer fire on their own and every funnel CTA would sit at
       pointer-events:none behind an open drawer.

       The lock exists to stop a second POST during a navigation that no longer
       happens there, so the interceptor calls this as soon as its add settles —
       success or failure — and the guard keeps its original meaning everywhere
       else. Released on failure too, so a declined add leaves a button the
       visitor can press again. */
    window.__tbfAtcRelease = release;

    /* Claims the page's single activation slot. Returns false when a previous
       activation already holds it, which is the caller's cue to cancel. */
    function activate() {
      if (locked) return false;
      locked = true;
      setBusy(true);
      releaseTimer = window.setTimeout(release, 15000);
      return true;
    }

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || !form.matches || !form.matches(TBF_ATC_FORMS)) return;
      if (activate()) return; /* First submit goes through untouched. */
      /* Duplicate: cancel it before the browser can queue a second POST, and
         keep it away from any downstream submit handler that would fetch its
         own /cart/add. */
      event.preventDefault();
      event.stopImmediatePropagation();
    }, true);

    /* Covers two cases: the quiz CTA, whose first click IS the activation, and
       every later click on any guarded control — a second click can land
       before the first one's submit event, or on a different section's button,
       so it is swallowed here rather than trusted to the element's own state.
       Pointer-events does not stop keyboard activation of a link, so this is
       also what blocks a second Enter on the focused quiz CTA. */
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      if (locked) {
        if (target.closest(TBF_GUARDED)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        return;
      }

      if (target.closest(TBF_QUIZ_CTA)) activate();
    }, true);

    window.addEventListener('pageshow', function (event) {
      if (event.persisted) release();
    });
  }

  function initFooter() {
    var footer = document.querySelector('.tbf-footer');
    if (!footer || footer.dataset.tbfFooterReady === '1') return;
    footer.dataset.tbfFooterReady = '1';

    var cols = footer.querySelectorAll('[data-tbf-footer-col]');
    if (!cols.length) return;

    // Must match the mobile breakpoint in sections/tbf-footer.liquid.
    var mq = window.matchMedia('(max-width: 640px)');

    function syncState(details) {
      var summary = details.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    }

    // Desktop: groups stay open, so the summary is just the column heading.
    // Mobile: groups start collapsed, so the footer is a short stack of headings.
    // Without JS the markup ships open on both, i.e. the previous footer behaviour.
    function apply() {
      var alwaysOpen = !mq.matches;
      Array.prototype.forEach.call(cols, function (details) {
        if (alwaysOpen) {
          if (!details.open) details.open = true;
        } else if (details.open) {
          details.open = false;
        }
        syncState(details);
      });
    }

    Array.prototype.forEach.call(cols, function (details) {
      var summary = details.querySelector('summary');
      if (!summary) return;

      // <details> already conveys expanded state, but only implicitly, so mirror
      // it on the summary where assistive tech and audits read it.
      details.addEventListener('toggle', function () {
        if (!mq.matches && !details.open) {
          // Desktop never stays collapsed, whatever activated the summary.
          details.open = true;
          return;
        }
        syncState(details);
      });

      // Desktop: the heading is not a control, so ignore activation entirely.
      summary.addEventListener('click', function (e) {
        if (!mq.matches) e.preventDefault();
      });
    });

    apply();
    mq.addEventListener('change', apply);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initStickyCta();
    initAtcGuard();
    initQuiz();
    initArticleShare();
    initStoryIngredients();
    initFooter();
  });
})();
